export default __webpack_public_path__ + "portfolio02.jpg";